import React from 'react';

type Mode = undefined | 'gradient' | 'gradient-reverse';

const getFillUrl = (mode: Mode) => {
  switch (mode) {
    case 'gradient':
      return 'url(#quote-gradient)';
    case 'gradient-reverse':
      return 'url(#quote-gradient-reverse)';
    default:
      return;
  }
};

const QuoteSvg = ({
  mode,
  ...props
}: {
  mode?: Mode;
} & { [key: string]: any }) => (
  <svg
    className="quote"
    width={104}
    height={48}
    viewBox="0 0 104 48"
    {...props}
  >
    <defs>
      <linearGradient id="quote-gradient" x1="50%" y1="50%" x2="125%" y2="50%">
        <stop
          offset={0}
          style={{
            stopColor: '#5472FF',
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#F054FF',
          }}
        />
      </linearGradient>
      <linearGradient
        id="quote-gradient-reverse"
        x1="-25%"
        y1="50%"
        x2="50%"
        y2="50%"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#F054FF',
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#5472FF',
          }}
        />
      </linearGradient>
    </defs>
    <path
      fill={getFillUrl(mode)}
      d="M0,48C0,21.49,21.49,0,48,0v21c-14.912,0-27,12.088-27,27H0z M77,48c0-14.912,12.088-27,27-27V0C77.49,0,56,21.49,56,48H77z"
    />
  </svg>
);

export default QuoteSvg;
